import { get } from '@ebay/presence-ui/lib/object-helpers';
import storeEvent from '@ebay/presence-ui/lib/store-event';
import TourTipState from '../../utils/tourtip-state';

const KEY = 'str-controlbar-wrap';
const SEL = {
    tourTipCloseBtn: '.str-controlbar__left-nav-btn-wrap .tourtip__close'
};

export default class {
    onCreate(input) {
        const catMod = get(input, 'page.modules.STORE_CATEGORIES_MODULE', {});
        this.leftNavBtnTrackOpen = JSON.stringify(get(catMod, 'toggleAction.action.trackingList.0', {}));
        this.leftNavBtnTrackClose = JSON.stringify(get(catMod, 'toggleAction.action.trackingList.1', {}));
        this.state = {
            leftNavBtnAriaExpanded: 'false',
            leftNavBtnTracking: this.leftNavBtnTrackOpen,
            leftNavBtnAriaLabel: get(catMod, 'label', ''),
            hasCategories: !!get(catMod, 'categories', false),
            tourTipText: get(catMod, 'toggleAction.tourTip.title.textSpans.0.text', ''),
            tourTipCloseText: get(catMod, 'toggleAction.tourTip.closeControl.accessibilityText', ''),
            tourTipIsOpen: false
        };
    }
    onMount() {
        this.root = this.getEl(KEY);
        storeEvent.toggleLeftNavDone.listen(data => {
            this.state.leftNavBtnAriaExpanded = `${data.isOpen}`; // Needs to be string
            this.state.leftNavBtnTracking = data.isOpen ? this.leftNavBtnTrackClose : this.leftNavBtnTrackOpen;
        });
        this.handleTourTip();
    }
    handleTourTip() {
        // Initialize TourTipState with a unique id
        this.tourTipState = new TourTipState('str-controlbar__left-nav-btn-tourtip');
        this.state.tourTipIsOpen = this.tourTipState.isOpen();
    }
    saveTourTipCollapse() {
        this.tourTipState.saveCollapse();
    }
    toggleLeftNav() {
        storeEvent.toggleLeftNav.dispatch();
        this.closeTourTip();
    }
    closeTourTip() {
        if (this.state.tourTipIsOpen) {
            // TODO: See if there's a programmatic way to close tourtip.
            const tourTipCloseBtn = this.root.querySelector(SEL.tourTipCloseBtn);
            if (tourTipCloseBtn) {
                tourTipCloseBtn.click();
            }
        }
    }
    openMobileCatLayer() {
        storeEvent.openMobileCatLayer.dispatch();
    }
}
